import IconButton from '@mui/material/IconButton'
import MoreVertIcon from '@mui/icons-material/MoreVert'

const DetailButton = ({disabled, onClick}) => {
    return (
        <IconButton aria-label='View details' onClick={onClick} disabled={disabled} sx={{ padding: '12px' }}>
            <MoreVertIcon />
        </IconButton>
    )
}

export default DetailButton
